/*
 * @创建文件时间: 2019-11-26 20:36:53
 * @最后修改人: lfq
 * @最后修改时间: 2020-06-13 15:53:30
 * @联系Qq:1360484677
 * @文件介绍: 日常养护_定量养护
 */
export default [
    {
        path: 'maintenanceQx',
        name: 'maintenanceQx',
        meta: {
            title: '千寻巡查记录',
            auth: true
        },
        component: () =>
            import ('@/views/conserve/workFlow/qxTable.vue')
    },
    {
        path: 'jobPlanMasterTable',
        name: 'jobPlanMasterTable',
        meta: {
            title: '月作业计划管理',
            auth: true
        },
        component: () =>
            import ('@/views/conserve/workFlow/jobPlanMasterTable')
    }, {
        path: 'disIntManagement',
        name: 'disIntManagement',
        meta: {
            title: '病害综合管理',
            auth: true
        },
        component: () =>
            import ('@/views/conserve/workFlow/disIntManagement')
    }, {
        path: 'inspectionRecordTable',
        name: 'inspectionRecordTable',
        meta: {
            title: '巡查记录',
            auth: true
        },
        component: () =>
            import ('@/views/conserve/workFlow/inspectionRecordTable')
    }, {
        path: 'diseaseSetTable',
        name: 'diseaseSetTable',
        meta: {
            title: '病害登记',
            auth: true
        },
        component: () =>
            import ('@/views/conserve/workFlow/diseaseSetTable')
    }, {
        path: 'workRecord',
        name: 'workRecord',
        meta: {
            title: '工作记录',
            auth: true
        },
        component: () =>
            import ('@/views/conserve/workFlow/workRecord')
    }, {
        path: 'minorReportTable',
        name: 'minorReportTable',
        meta: {
            title: '小修通报单',
            auth: true
        },
        component: () =>
            import ('@/views/conserve/workFlow/minorReportTable')
    }, {
        path: 'safetyFacilityLayTable',
        name: 'safetyFacilityLayTable',
        meta: {
            title: '安全布设记录',
            auth: true
        },
        component: () =>
            import ('@/views/conserve/workFlow/safetyFacilityLayTable')
    }, {
        path: 'maintainORTable',
        name: 'maintainORTable',
        meta: {
            title: '维修记录',
            auth: true
        },
        component: () =>
            import ('@/views/conserve/workFlow/maintainORTable')
    }, {
        path: 'acceptanceApplyTable',
        name: 'acceptanceApplyTable',
        meta: {
            title: '验收申请',
            auth: true
        },
        component: () =>
            import ('@/views/conserve/workFlow/acceptanceApplyTable')
    }, {
        path: 'acceptanceApplyTableNew',
        name: 'acceptanceApplyTableNew',
        meta: {
            title: '验收申请（新）',
            auth: true
        },
        component: () =>
            import ('@/views/conserve/workFlow/acceptanceApplyTableNew')
    },
    {
        path: 'rectificationOrderTable',
        name: 'rectificationOrderTable',
        meta: {
            title: '整改通知',
            auth: true
        },
        component: () =>
            import ('@/views/conserve/workFlow/rectificationOrderTable')
    }, {
        path: 'maintARTable',
        name: 'maintARTable',
        meta: {
            title: '验收记录',
            auth: true
        },
        component: () =>
            import ('@/views/conserve/workFlow/maintARTable')
    },
    {
        path: 'maintARTableNew',
        name: 'maintARTableNew',
        meta: {
            title: '维修记录卡片',
            auth: true
        },
        component: () =>
            import ('@/views/conserve/workFlow/maintARTableNew')
    },
    {
        path: 'acceptRecord',
        name: 'acceptRecord',
        meta: {
            title: '养护作业验收记录',
            auth: true
        },
        component: () =>
            import ('@/views/conserve/workFlow/acceptRecord')
    },
    {
        path: 'jsAmapData',
        name: 'jsAmapData',
        meta: {
            title: '云采数据',
            auth: true
        },
        component: () =>
            import ('@/views/conserve/yunData/jsAmapData')
    },
    {
        path: 'jsBridge',
        name: 'jsBridge',
        meta: {
            title: '桥梁云采数据',
            auth: true
        },
        component: () =>
            import ('@/views/conserve/yunData/jsAmap/jsBridge')
    },
    {
        path: 'jsCulvert',
        name: 'jsCulvert',
        meta: {
            title: '涵洞云采数据',
            auth: true
        },
        component: () =>
            import ('@/views/conserve/yunData/jsAmap/jsCulvert')
    },
    {
        path: 'jsTunnel',
        name: 'jsTunnel',
        meta: {
            title: '隧道云采数据',
            auth: true
        },
        component: () =>
            import ('@/views/conserve/yunData/jsAmap/jsTunnel')
    },
    {
        path: 'jsRoute',
        name: 'jsRoute',
        meta: {
            title: '路线桩号云采数据',
            auth: true
        },
        component: () =>
            import ('@/views/conserve/yunData/jsAmap/jsRoute')
    },
    {
        path: 'businessAssess',
        name: 'businessAssess',
        meta: {
            title: '业务考核',
            auth: true
        },
        component: () =>
            import ('@/views/conserve/yunData/businessAssess')
    },
    {
        path: 'oldJobPlan',
        name: 'oldJobPlan',
        meta: {
            title: '往年月计划',
            auth: true
        },
        component: () =>
            import ('@/views/conserve/yunData/oldJobPlan')
    },
    {
        path: 'workAreaSelect',
        name: 'workAreaSelect',
        meta: {
            title: '布设作业区',
            auth: true
        },
        component: () =>
            import ('@/views/conserve/yunData/workAreaSelect')
    },
    {
        path: 'mainARCard',
        name: 'mainARCard',
        meta: {
            title: '验收记录卡片',
            auth: true
        },
        component: () =>
            import ('@/views/conserve/yunData/mainARCard')
    },
    {
        path: 'conserveECharts',
        name: 'conserveECharts',
        meta: {
            title: '日常养护统计',
            auth: true
        },
        component: () =>
            import ('@/views/echarts/conserveECharts')
    }
]